import { Navigate } from 'react-router-dom';
import { useCurrentUser } from '~/shared/hooks/useCurrentUser';

/**
 * "My profile" route (/profile). Redirects to the current user's profile view.
 */
const ProfilePage = () => {
  const { user, isLoading } = useCurrentUser();

  if (isLoading) {
    return null;
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return <Navigate to={`/profile/${user.id}`} replace />;
};

export default ProfilePage;
